const ko = {
  // Header
  nav_home: '홈',
  nav_booking: '예약하기',
  nav_therapists: '테라피스트',
  menu_label: '메뉴',

  // Hero
  hero_badge: 'Premium Thai Massage',
  hero_title: '태국 최고의\n마사지를 경험하세요',
  hero_subtitle: '파타야, 푸켓, 방콕, 코랏에서 전문 테라피스트의 프리미엄 마사지를 예약하세요',
  hero_book_now: '지금 예약하기',
  hero_view_therapists: '테라피스트 보기',
  stat_therapists: '전문 테라피스트',
  stat_locations: '지역',
  stat_rating: '평균 평점',

  // Features
  feature_gps_title: 'GPS 자동 감지',
  feature_gps_desc: '현재 위치에서 가장 가까운 지역을 자동으로 찾아드립니다',
  feature_booking_title: '간편한 예약',
  feature_booking_desc: '5단계로 간편하게 마사지를 예약하세요',
  feature_verified_title: '검증된 테라피스트',
  feature_verified_desc: '경력과 후기로 검증된 전문 테라피스트',

  // Nearby therapists section
  nearby_title: '내 주변 테라피스트',
  nearby_subtitle: 'GPS 기반으로 가장 가까운 지역의 테라피스트를 추천합니다',
  nearby_loading: '위치를 감지하고 있습니다...',
  nearby_error: '위치를 감지할 수 없습니다',
  nearby_retry: '다시 시도',
  nearby_distance: '{distance}km 거리',
  nearby_book: '예약하기',

  // Locations section
  section_locations_title: '예약 가능 지역',
  section_locations_subtitle: '태국 5개 주요 도시에서 서비스를 제공합니다',
  loc_book: '예약하기',

  // Courses section
  section_courses_title: '마사지 코스',
  section_courses_subtitle: '다양한 마사지 프로그램을 만나보세요',

  // Therapists section
  section_therapists_title: '인기 테라피스트',
  section_therapists_subtitle: '최고 평점의 테라피스트를 소개합니다',
  view_all_therapists: '전체 테라피스트 보기',

  // CTA
  cta_title: '지금 바로 예약하세요',
  cta_subtitle: '최고의 타이 마사지 경험이 기다리고 있습니다',
  cta_book: '예약하기',

  // Footer
  footer_copyright: '© 2026 Thai Massage Booking. All rights reserved.',

  // Booking Steps
  step_location: '지역 선택',
  step_course: '코스 선택',
  step_therapist: '테라피스트',
  step_datetime: '날짜/시간',
  step_confirm: '확인',

  // Booking - Step 1
  booking_location_title: '지역을 선택해주세요',
  booking_location_desc: '마사지를 받으실 지역을 선택하세요',
  gps_detect: '현재 위치로 자동 감지',
  gps_loading: '위치 감지 중...',

  // Booking - Step 2
  booking_course_title: '마사지 코스를 선택해주세요',
  booking_course_desc: '원하시는 마사지 종류와 시간을 선택하세요',
  duration_min: '{min}분',

  // Booking - Step 3
  booking_therapist_title: '테라피스트를 선택해주세요',
  booking_therapist_desc: '{location}에서 활동하는 테라피스트입니다',
  no_therapist: '선택하신 지역과 코스에 맞는 테라피스트가 없습니다.',
  no_therapist_suggest: '다른 코스를 선택해주세요.',

  // Booking - Step 4
  booking_datetime_title: '날짜와 시간을 선택해주세요',
  booking_datetime_desc: '예약하실 날짜와 시간을 선택하세요',
  date_select: '날짜 선택',
  time_select: '시간 선택',
  time_placeholder: '먼저 날짜를 선택해주세요',
  time_notice: '거리에 따라 도착까지 최대 2시간이 소요될 수 있습니다. 가능한 여유 있는 시간을 선택해주세요.',

  // Booking - Step 5
  booking_confirm_title: '예약 정보를 확인해주세요',
  booking_confirm_desc: '모든 정보를 확인하고 연락처를 입력해주세요',
  summary_location: '지역',
  summary_course: '코스',
  summary_price: '가격',
  summary_therapist: '테라피스트',
  summary_date: '날짜',
  summary_time: '시간',
  health_check_title: '건강 상태 확인',
  health_check_desc: '건강 상태나 통증이 있는 부위, 마사지를 피하고 싶은 부위가 있으면 알려주세요.',
  health_check_placeholder: '예: 고혈압이 있어요 / 오른쪽 어깨를 다쳐서 상체는 가볍게 해주세요 / 허리 디스크가 있어서 허리는 빼주세요',
  health_check_examples: '예: 고혈압이 있어요 / 오른쪽 어깨를 다쳐서 상체는 가볍게 해주세요 / 허리 디스크가 있어서 허리는 빼주세요',
  contact_title: '연락처 정보',
  contact_name: '이름',
  contact_name_placeholder: '이름을 입력해주세요',
  contact_phone: '전화번호',
  contact_phone_placeholder: '전화번호를 입력해주세요',
  contact_email: '이메일',
  contact_email_placeholder: '이메일 주소를 입력해주세요',
  contact_note: '요청사항',
  contact_note_placeholder: '특별한 요청사항이 있으면 입력해주세요',
  required_mark: '*',

  // Navigation buttons
  btn_prev: '이전',
  btn_next: '다음',
  btn_complete: '예약 완료',

  // Therapist card
  age_suffix: '세',
  experience_years: '경력 {years}년',

  // Therapist list page
  tl_title: '테라피스트',
  tl_subtitle: '경력과 전문성으로 검증된 최고의 테라피스트를 만나보세요',
  tab_all: '전체',

  // Confirmation page
  conf_empty_title: '예약 정보가 없습니다',
  conf_empty_desc: '예약 페이지에서 예약을 진행해주세요.',
  conf_empty_btn: '예약하기',
  conf_success_title: '예약이 완료되었습니다!',
  conf_success_subtitle: '예약 정보가 확인되었습니다. 감사합니다.',
  conf_preparation_title: '예약이 접수되지 않았습니다',
  conf_preparation_subtitle: '현재 서비스가 준비중이라 예약은 확정되지 않았습니다. 정식 오픈 후 연락드리겠습니다.',
  conf_preparation_notice: '현재 서비스 준비중이므로 본 예약은 확정 예약이 아닙니다.',
  conf_booking_id: '예약번호',
  conf_detail_title: '예약 상세 정보',
  conf_label_location: '지역',
  conf_label_course: '마사지 코스',
  conf_label_price: '가격',
  conf_label_therapist: '테라피스트',
  conf_label_date: '날짜',
  conf_label_time: '시간',
  conf_label_email: '이메일',
  conf_label_contact: '연락처',
  conf_label_note: '요청사항',
  conf_notice_title: '안내사항',
  conf_notice_1: '거리에 따라 도착까지 최대 2시간이 소요될 수 있습니다.',
  conf_notice_2: '예약 변경 및 취소는 전화로 문의해주세요.',
  conf_notice_3: '현장에서 현금 또는 카드로 결제하실 수 있습니다.',
  conf_btn_home: '홈으로',
  conf_btn_new: '새 예약하기',

  // Geolocation errors
  GEO_NOT_SUPPORTED: 'GPS를 지원하지 않는 브라우저입니다.',
  GEO_PERMISSION_DENIED: '위치 접근이 거부되었습니다. 수동으로 지역을 선택해주세요.',
  GEO_POSITION_UNAVAILABLE: '위치 정보를 사용할 수 없습니다.',
  GEO_TIMEOUT: '위치 요청 시간이 초과되었습니다.',
  GEO_UNKNOWN: '알 수 없는 오류가 발생했습니다.',

  // SEO
  seo_home_title: '태국 출장 마사지 예약 | Bangkok In Home Massage',
  seo_home_desc: '방콕, 파타야, 푸켓, 치앙마이, 코랏 호텔·숙소로 검증된 테라피스트가 방문하는 프리미엄 출장 마사지. 타이 전통, 아로마, 오일 마사지를 온라인으로 간편하게 예약하세요.',
  seo_therapists_title: '출장 마사지 테라피스트 | Bangkok In Home Massage',
  seo_therapists_desc: '방콕, 파타야, 푸켓, 치앙마이, 코랏에서 경력과 후기로 검증된 전문 테라피스트를 만나보세요. 프로필, 평점, 전문 분야를 확인하고 바로 예약할 수 있습니다.',
  seo_booking_title: '출장 마사지 온라인 예약 | Bangkok In Home Massage',
  seo_booking_desc: '지역, 코스, 테라피스트를 선택하고 원하는 날짜와 시간에 출장 마사지를 예약하세요. 방콕, 파타야, 푸켓, 치앙마이, 코랏 호텔·숙소로 방문합니다.',

  // Body info
  height_label: '키',
  weight_label: '몸무게',

  // GPS therapist list
  gps_find_nearby: '내 위치에서 가까운 관리사 찾기',
  gps_nearby_active: '가까운 순서로 표시 중',

  // Notices
  notice_punctual: '테라피스트가 예약하신 날짜와 시간에 맞춰 방문합니다. 정확한 시간에 준비해주세요.',
  notice_no_sexual: '본 서비스는 전문 마사지 서비스입니다. 성적인 서비스는 일체 제공되지 않습니다.',

  // Guide section
  guide_title: '이용 안내',
  guide_subtitle: '쾌적한 서비스를 위해 아래 안내사항을 확인해 주세요',
  guide_before_title: '이용 전 안내',
  guide_before_text: '시술 전 가벼운 샤워를 권장합니다. 식사 직후에는 피해 주시고, 과음 상태에서는 시술이 거부될 수 있습니다. 기저질환(고혈압, 심장질환 등)이 있거나 임산부인 경우 예약 시 요청사항에 미리 기재해 주세요.',
  guide_booking_title: '예약 안내',
  guide_booking_text: '거리에 따라 테라피스트 도착까지 최대 2시간이 소요될 수 있으므로 여유 있는 시간을 선택해 주세요. 예약 변경 및 취소는 전화로 문의해 주세요.',
  guide_session_title: '시술 안내',
  guide_session_text: '테라피스트가 예약하신 시간에 맞춰 숙소로 방문합니다. 시술 중 불편한 부분이 있으면 즉시 말씀해 주세요. 본 서비스는 전문 마사지 서비스이며, 성적인 서비스는 일체 제공되지 않습니다.',
  guide_after_title: '시술 후 안내',
  guide_after_text: '충분한 수분을 섭취해 주세요. 일시적인 근육통이나 피로감은 정상이며 2~3일 내에 회복됩니다. 당일 과음과 격한 운동은 삼가 주세요.',
  guide_payment_title: '결제 안내',
  guide_payment_text: '현장에서 현금 또는 카드로 결제하실 수 있습니다.',

  // FAQ
  faq_q1: '출장 마사지는 어떻게 이용하나요?',
  faq_a1: '지역을 선택하고, 마사지 종류를 고른 후, 테라피스트를 선택하고 날짜와 시간을 예약하세요. 테라피스트가 호텔이나 숙소로 방문합니다.',
  faq_q2: '어떤 지역에서 서비스를 이용할 수 있나요?',
  faq_a2: '방콕, 파타야, 푸켓, 치앙마이, 코랏 5개 지역에서 전문 출장 마사지 서비스를 제공합니다.',
  faq_q3: '예약 변경이나 취소는 어떻게 하나요?',
  faq_a3: '예약 변경 및 취소는 전화로 문의해주세요. 현장에서 현금 또는 카드로 결제 가능합니다.',

  // 404
  notfound_title: '페이지를 찾을 수 없습니다',
  notfound_desc: '요청하신 페이지가 존재하지 않거나 이동되었습니다.',
  notfound_home: '홈으로 돌아가기',
};

export default ko;
